module.exports = __webpack_public_path__ + "img/yingshi.f9f64213.png";